module.exports = new __parcel__URL__("saved_souls_level_1.ec474c84.png").toString();